import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import {
  groupInsights,
  groupRecommendations,
  myGroupsActivity,
  trendingGroups,
  upcomingGroupEvents,
} from "../data";

const NavRight = () => {
  const [urlStudio, setUrlStudio] = useState("");
  const [urlStudioTest, setUrlStudioTest] = useState("");

  useEffect(() => {
    setUrlStudio(`http://localhost:5173/studio`);
    setUrlStudioTest(`https://test.taganow.vn/studio`);
  }, []);
  return (
    <div className="h-[calc(100vh-70px)] fixed hidden xl:block w-[350px] top-[70px] right-0 overflow-hidden ">
      <div className="w-full flex flex-col h-full overflow-y-auto p-4 space-y-6">
        {/* My Groups Activity */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold flex items-center">
              🔔 Hoạt động nhóm của bạn
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {myGroupsActivity.map((activity, index) => (
              <div
                key={index}
                className="flex items-center space-x-3 p-2 hover:bg-gray-50 rounded-lg cursor-pointer transition-colors"
              >
                <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center text-sm">
                  {activity.emoji}
                </div>
                <div className="flex-1 min-w-0">
                  <h5 className="text-sm font-medium text-gray-900 truncate">
                    {activity.group}
                  </h5>
                  <p className="text-xs text-gray-600">{activity.activity}</p>
                  <p className="text-xs text-gray-400">{activity.time}</p>
                </div>
              </div>
            ))}
            <Button
              variant="ghost"
              className="w-full text-xs text-blue-600"
            >
              Xem tất cả hoạt động
            </Button>
          </CardContent>
        </Card>

        {/* Group Performance Insights */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold flex items-center">
              📈 Thống kê nhóm của bạn
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {groupInsights.map((insight, index) => (
              <div
                key={index}
                className="flex justify-between items-center"
              >
                <span className="text-xs text-gray-600">{insight.metric}</span>
                <div className="text-right">
                  <div className="text-sm font-semibold text-gray-900">
                    {insight.value}
                  </div>
                  <div className="text-xs text-green-600">{insight.change}</div>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        {/* Trending Groups */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold flex items-center">
              🔥 Nhóm thịnh hành
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-3">
            {trendingGroups.map((group, index) => (
              <div
                key={index}
                className="flex justify-between items-center hover:bg-gray-50 p-2 rounded-lg cursor-pointer transition-colors"
              >
                <div className="flex items-center space-x-2">
                  <span className="text-lg">{group.emoji}</span>
                  <div>
                    <span className="text-sm font-medium text-gray-900 block">
                      {group.name}
                    </span>
                    <p className="text-xs text-gray-500">
                      {group.members} thành viên
                    </p>
                  </div>
                </div>
                <Badge
                  variant="outline"
                  className="text-green-600 border-green-200 text-xs"
                >
                  {group.growth}
                </Badge>
              </div>
            ))}
            <Button
              variant="ghost"
              className="w-full text-xs text-blue-600"
            >
              Khám phá thêm nhóm
            </Button>
          </CardContent>
        </Card>

        {/* Group Recommendations */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold flex items-center">
              ✨ Nhóm đề xuất
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {groupRecommendations.map((group, index) => (
              <div
                key={index}
                className="border-l-4 border-l-blue-500 pl-3 hover:bg-gray-50 p-2 rounded-r-lg cursor-pointer transition-colors"
              >
                <div className="flex items-start space-x-2 mb-2">
                  <span className="text-lg">{group.emoji}</span>
                  <div className="flex-1 min-w-0">
                    <h5 className="text-sm font-medium text-gray-900 truncate">
                      {group.name}
                    </h5>
                    <p className="text-xs text-gray-600 line-clamp-2">
                      {group.description}
                    </p>
                  </div>
                </div>
                <div className="flex items-center justify-between">
                  <div className="text-xs text-gray-500">
                    {group.members.toLocaleString()} thành viên •{" "}
                    {group.mutualMembers} bạn chung
                  </div>
                  <Button
                    size="sm"
                    variant="outline"
                    className="text-xs px-2 py-1"
                  >
                    Tham gia
                  </Button>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        {/* Upcoming Group Events */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold flex items-center">
              📅 Sự kiện nhóm sắp tới
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            {upcomingGroupEvents.map((event, index) => (
              <div
                key={index}
                className="border border-gray-50 rounded-lg p-3 hover:border-blue-300 cursor-pointer transition-colors"
              >
                <h5 className="text-sm font-medium text-gray-900 mb-1">
                  {event.title}
                </h5>
                <p className="text-xs text-blue-600 mb-2">{event.group}</p>
                <div className="flex items-center justify-between text-xs text-gray-600 mb-2">
                  <span>📍 {event.date}</span>
                  <Badge
                    variant="outline"
                    className="text-xs"
                  >
                    {event.type}
                  </Badge>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-xs text-gray-500">
                    {event.attendees} người tham gia
                  </span>
                  <Button
                    size="sm"
                    variant="outline"
                    className="text-xs px-2 py-1"
                  >
                    Tham gia
                  </Button>
                </div>
              </div>
            ))}
          </CardContent>
        </Card>

        {/* Quick Group Actions */}
        <Card>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-semibold">
              ⚡ Hành động nhanh
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <Button
              variant="outline"
              size="sm"
              className="w-full justify-start text-xs"
            >
              🎯 Tạo nhóm mới
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="w-full justify-start text-xs"
            >
              💼 Đăng việc làm trong nhóm
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="w-full justify-start text-xs"
            >
              📢 Tạo bài viết nhóm
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="w-full justify-start text-xs"
            >
              🎪 Tổ chức sự kiện nhóm
            </Button>
          </CardContent>
        </Card>

        {/* Premium Group Features */}
        <Card>
          <CardContent className="p-6 text-center">
            <div className="bg-gradient-to-r from-purple-100 to-blue-100 p-6 rounded-lg">
              <h4 className="font-semibold text-gray-700 mb-2">
                👑 Nâng cấp nhóm
              </h4>
              <p className="text-xs text-gray-600 mb-3">
                Mở khóa tính năng cao cấp cho nhóm của bạn
              </p>
              <NavLink
                to={urlStudio}
                className="block w-full"
                target="_blank"
              >
                <Button
                  variant="link"
                  size="lg"
                  className="w-full "
                >
                  Taga studio Local
                </Button>
              </NavLink>
              <NavLink
                to={urlStudioTest}
                className="block w-full"
                target="_blank"
              >
                <Button
                  variant="link"
                  size="lg"
                  className="w-full "
                >
                  Taga studio Test
                </Button>
              </NavLink>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
export default NavRight;
